export enum UserAccountState {
    Draft = 'Draft',
    EmailNotVerified = 'EmailNotVerified',
    EmailNotVerifiedWrongAttempt = 'EmailNotVerifiedWrongAttempt',
    Active = 'Active',
    Canceled = 'Canceled'
};